/**
 * Error Response Message Dictionary
 * Maps error codes to user-friendly messages
 * These messages come from backend API responses
 */

export const ERROR_MESSAGES = {
  "INSUFFICIENT CREDIT":
    "Insufficient credits. Please recharge your Account.",
};

/**
 * Plan Exhaust Message Dictionary
 * Keys match backend PlanStatus enum .value strings exactly.
 * Used when the middleware returns HTTP 403 with a plan-limit message.
 */
export const PLAN_EXHAUST_MESSAGES = {
  "INSUFFICIENT CREDIT":
    "Insufficient credits. Please recharge your Account.",
};

/**
 * Resolves a plan-exhaust message from a backend 403 response.
 * @param {string|undefined} messageKey - The message field from the API response.
 * @returns {string} A user-friendly message string.
 */
export const getPlanExhaustMessage = (messageKey) =>
  PLAN_EXHAUST_MESSAGES[messageKey] ||
  ERROR_MESSAGES.UnexpectedError;

